export default __webpack_public_path__ + "static/media/company.5c69635c.svg";